import { useMutation } from '@apollo/client';

import CREATE_PARTICIPATION_INPUT from '@graphql/createParticipationInput.graphql';

export const useCreateParticipationInput = () => {
  const [createFunction, { loading, error }] = useMutation(CREATE_PARTICIPATION_INPUT);

  const createParticipationInput = (input) => {
    return createFunction({ variables: { input } });
  };

  return [createParticipationInput, { loading, error }];
};
